import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { emailRegex } from "../assets/enviroment";
import { myURL } from "../assets/enviroment";
import axios from "axios";
import { Spinner } from "react-bootstrap";
//import { set } from "mongoose";

const DeleteMonitorUser = () => {
  const [userEmail, setUserEmail] = useState("");
  const [error, setError] = useState("");
  const [sucess, setSucess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setUserEmail(e.target.value);
  };
  const handleSubmit = async (e) => {
    setLoading(true);
    try {
      e.preventDefault();
      if (!emailRegex.test(userEmail)) {
        console.log("El usuario no es un email valido");
        setError("El usuario no es un email valido");
        setLoading(false);
        return;
      }
      const res = await axios.delete(`${myURL}deleteMonitorUser/${userEmail}`);
      const data = await res.data;
      setSucess(data.msg);
      console.log("data fetch....", data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      const status = error.response.status;
      const data = error.response.data;
      console.log("status....", status);
      console.log("data....", data);
      setError(data.msg);
      setLoading(false);
    }
  };
  return (
    <div className="card w-50 ms-auto me-auto p-2">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>User email</Form.Label>
          <Form.Control
            onChange={handleChange}
            value={userEmail}
            name="email"
            type="email"
            placeholder="Enter email"
          />
        </Form.Group>
        <button type="submit" className="btn btn-outline-danger d-block ms-auto me-auto">
          Delete User
        </button>
      </Form>
      {loading && <Spinner className="d-block ms-auto me-auto my-3" animation="border" variant="primary" />}
      {error && <div className="alert alert-danger my-3">{error}</div>}
      {sucess && <div className="alert alert-success my-3">{sucess}</div>}
    </div>
  );
};

export default DeleteMonitorUser;
